module.exports = __webpack_public_path__ + "static/assets/2058ab032eeaff26585c23e0c593e2cf.svg";